import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function XIcon(props: IconProps) {
  return (
    <Icon fill="none" viewBox="0 0 1279 1279" {...props}>
      <Box
        as="path"
        fill="currentColor"
        d="M754.163 545.284 1200.89 26h-105.86L707.137 476.887 397.328 26H40l468.492 681.821L40 1252.37h105.866l409.625-476.152 327.181 476.152H1240L754.137 545.284h.026ZM609.165 713.828l-47.468-67.894-377.686-540.24h162.604l304.797 435.991 47.468 67.894 396.2 566.721H932.476L609.165 713.854v-.026Z"
      />
    </Icon>
  );
}
